module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    attrs: {
      "src": _vm.src,
      "alt": _vm.name
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onClick($event)
      },
      "mouseenter": _vm.mouseEnter,
      "mouseOver": _vm.mouseOver,
      "mouseMove": _vm.mouseMove,
      "mouseleave": _vm.mouseLeave
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47528894!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/components/ImageComponent.vue
// module id = 350
// module chunks = 1